import { Navigate } from 'react-router-dom';

import { FormWrapper, Main, PageWrapper } from '../login/index.styles';

import Footer from '../../footer';
import Header from '../../header';
import Heading from '../../heading';
import VerifyForm from './verify_form';

import useLocationParams from '../../../hooks/useLocationParams';

import type { Account } from '@rewardopl/types';

export default function VerifyPage() {
  const [params] = useLocationParams() as [{ id?: Account['_id']; token?: string }, () => void];

  const { id, token } = params;

  const hasParams = id && token;

  if (!hasParams) {
    return <Navigate to="/" />;
  }

  return (
    <PageWrapper>
      <Header />
      <FormWrapper>
        <Main>
          <Heading align="center">Verify email</Heading>
          <VerifyForm id={id} token={token} />
        </Main>
      </FormWrapper>
      <Footer />
    </PageWrapper>
  );
}
